import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import router from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'WksOpenInputBtn',
  props: {
    routeName: {type: String, required: true},
    src: String,
},
  emits: ["click"],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("img", {
      src: __props.src,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', __props.routeName)))
    }, null, 8, _hoisted_1)
  ]))
}
}

})